const authorizationInitialState = {
  permissionsByTenant: {}, // карта tenant -> string[] из /me
  fetching: false,
};

const me = (state = authorizationInitialState, action) => {
  switch (action.type) {
    case 'FETCH_ME':
      return {
        ...state,
        fetching: true,
      };

    case 'FETCH_ME_SUCCESS':
      return {
        ...state,
        fetching: false,
        permissionsByTenant: action.permissionsByTenant || {},
      };

    case 'FETCH_ME_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    default:
      return state;
  }
};

export default me;

export const getPermissionsByTenant = (state) => state.permissionsByTenant;

export const isFetchingMyPermissions = (state) => state.fetching;
